import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: '세척 시간은 얼마나 걸리나요?',
      answer: '평균 3–4일 정도가 소요됩니다.가능한 경우 더 빠르게 진행해드립니다.',
    },
    {
      question: '어떤 종류의 신발을 세척할 수 있나요?',
      answer: '모든 운동화·스니커즈류 세탁이 가능합니다. \n다만 아래와 같은 경우는 손상 위험으로 세탁이 제한될 수 있습니다. \n•도색·코팅층이 오래된 신발 \n•심한 손상(찢어짐·접착 해체 등)이 있는 경우 \n  •전문 복원 서비스가 필요한 경우',
    },
    {
      question: '픽업과 배송은 어떻게 진행되나요?',
      answer: '스니커케어는 고객의 편의를 위해 문 앞 수거·문 앞 배송 방식으로 운영합니다. \n•수거: 결제 확인 후, 가장 가까운 수거일 오전 9시에 신발을 수거합니다. \n(수거 1시간 전인 오전 8시에 안내 메시지가 발송됩니다.)\n•배송: 작업이 완료되면 저녁 8시부터 배송이 진행됩니다.\n(배송 예정 안내 → 배송 완료 안내 순으로 메시지가 발송됩니다.)\n신발은 수거 시간 전까지 문 앞에 준비해주세요.',
    },
    {
      question: '결제는 언제 하나요?',
      answer: '스니커케어는 선결제 후 수거 방식으로 운영됩니다. \n•주문 접수 → 접수 및 결제 안내 발송•결제 확인 후 → 수거 일정 자동 반영 \n•결제되지 않은 주문은 자동으로 보류됩니다(계좌이체 기반이며, 확인 후 즉시 알림톡이 발송됩니다.)',
    },
    {
      question: '취소나 환불이 가능한가요?',
      answer: '픽업 전까지는 전액 환불이 가능합니다. 세척이 시작된 이후에는 취소가 어렵습니다.',
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="rounded-xl bg-card p-6 shadow-lg">
      <h3 className="mb-6 text-xl font-bold text-foreground">자주 묻는 질문</h3>
      <div className="space-y-4">
        {faqs?.map((faq, index) => (
          <div
            key={index}
            className="overflow-hidden rounded-lg border border-border transition-all duration-200"
          >
            <button
              onClick={() => toggleFAQ(index)}
              className="flex w-full items-center justify-between p-4 text-left transition-colors hover:bg-muted/30"
            >
              <span className="font-semibold text-foreground">{faq?.question}</span>
              <Icon
                name={openIndex === index ? 'ChevronUp' : 'ChevronDown'}
                size={20}
                className="flex-shrink-0 text-muted-foreground transition-transform"
              />
            </button>
            
            {openIndex === index && (
              <div className="border-t border-border bg-muted/20 p-4">
                <p className="text-sm leading-relaxed text-muted-foreground whitespace-pre-line">{faq?.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQSection;